import { produce } from 'immer';
import * as types from '../constants';

export const initialState = {
  loading: false,
  memberShortDetail: null,
  error: null,
  initialPublicContact: null,
  publicContact: null,
};
/* eslint-disable default-case, no-param-reassign */
const memberPreviewReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case types.GET_MEMBER_SHORT_DETAIL_PREVIEW:
        draft.loading = true;
        draft.error = null;
        break;
      case types.GET_MEMBER_SHORT_DETAIL_PREVIEW_SUCCESS:
        draft.loading = false;
        draft.memberShortDetail = action.data;
        break;
      case types.GET_MEMBER_SHORT_DETAIL_PREVIEW_ERROR:
        draft.loading = false;
        draft.error = action.error;
        break;
    }
  });
export default memberPreviewReducer;
